import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'

function IdentityConfirmationSideMenu() {
  return <OnboardingStepperSideMenu />
}

export { IdentityConfirmationSideMenu }
